import { parseDate, formatDate } from 'shared-components';
import { Tag, TagLabel, Tooltip, TagProps, Box } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMoneyBillTransfer } from '@fortawesome/pro-regular-svg-icons';
import { ITag, TransactionStatus } from 'api-paths-cas';

export const TransfermateTag = ({ tag, tagProps }: { tag: ITag; tagProps?: TagProps }) => {
  const paymentsSum = tag.payments.reduce((sum, { amount }) => sum + amount, 0);
  const labelEnding = tag.paymentStatus === TransactionStatus.Pending ? 'pending' : 'paid';
  const label = `£${paymentsSum} ${labelEnding}`;

  return (
    <Tooltip
      hasArrow
      placement="bottom"
      label={
        <Box fontSize={'xs'}>
          <Box fontWeight={500}>
            TransferMate payments {tag.paymentStatus === TransactionStatus.Paid ? 'received' : 'pending'}
          </Box>
          {tag.payments.map(payment => (
            <Box key={payment.transactionId}>
              <Box as="span" paddingRight={2}>
                Payment {formatDate(parseDate(payment.initiatedDate), 'DD MMM YYYY HH:mm')}
              </Box>
              £{payment.amount}
            </Box>
          ))}
        </Box>
      }
    >
      <Tag size="xs" variant="solid" data-selector={`tag-${tag.id}`} {...tagProps} opacity={0.8}>
        <TagLabel textOverflow="ellipsis" overflow="hidden" whiteSpace="nowrap" noOfLines={null}>
          <FontAwesomeIcon fixedWidth icon={faMoneyBillTransfer} /> {label}
        </TagLabel>
      </Tag>
    </Tooltip>
  );
};
